import { render, staticRenderFns } from "./AppleWatchIcon.vue?vue&type=template&id=af2ae6ee&"
import script from "./AppleWatchIcon.vue?vue&type=script&lang=js&"
export * from "./AppleWatchIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports